module.exports = __webpack_public_path__ + "static/media/COS_ROC.c04e81f1.jpg";